import { useEffect, useRef, useCallback } from "react";
import { sanitizeHtml } from '../../../util/sanitizeHtml';
import { updateAlertMessage } from "../../../api-integration/common.slice";
import { getTranslatedText } from "../../../util/util";
import usePageTranslation from "../../../hooks/ui/usePageTranslation";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";


export const Alert = () => {
  const dispatch = useAppDispatch();
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const PageTranslation = usePageTranslation();

  const alertMessage = useAppSelector((state) => state.commonSlice.alertMessage);
  const user = useAppSelector((state) => state.commonSlice.user);
  const timeoutValue = alertMessage?.timeout || user?.usrMessageAlertDuration || Number(process.env.REACT_APP_ALERT_TIMEOUT);  

  const closeAlert = useCallback(() => {
    dispatch(updateAlertMessage(null));
  }, [dispatch]);

  useEffect(() => {
    // Clear any existing auto-close timer.
    // This ensures that when a new alert arrives (especially a manual-dismiss one),
    // any previous timer does not close or interfere with the new alert.
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }

    // If manual dismiss → do not set timeout
    if (!alertMessage || alertMessage.isManualDismiss) {
      return;
    }
    timeoutIdRef.current = setTimeout(closeAlert, timeoutValue);
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [alertMessage, timeoutValue, closeAlert]);

  if (!alertMessage?.status || !alertMessage.message?.trim()) {
    return null;
  }

  return (
    <div className="alert-container">
      {
        alertMessage.status === 'success' &&
        <div 
          key={alertMessage.message} 
          className="alert alert-primary alert-dismissible fade show" 
          role="alert"
        > 
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(alertMessage.message) }}  />
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label={getTranslatedText('close.text', PageTranslation)} onClick={closeAlert}></button>
        </div>
      }
      {
        alertMessage.status === 'error' &&
        <div 
          key={alertMessage.message}
          className="alert alert-danger alert-dismissible fade show" 
          role="alert"
        >
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(alertMessage.message) }}  />
          <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label={getTranslatedText('close.text', PageTranslation)} onClick={closeAlert}></button>
        </div>
      }
    </div>
  )
}
